export const FILESPACE_QUIT_RETRY_COUNT = 3;
